module.exports = __webpack_public_path__ + "img/shrimp_th_new_0005.11668ac3.png";